import { render, staticRenderFns } from "./TimeSplash.vue?vue&type=template&id=605f27b3&scoped=true&"
import script from "./TimeSplash.vue?vue&type=script&lang=js&"
export * from "./TimeSplash.vue?vue&type=script&lang=js&"
import style0 from "./TimeSplash.vue?vue&type=style&index=0&id=605f27b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605f27b3",
  null
  
)

export default component.exports